import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';

import {
  arrayOf as arrayType,
  params,
  shape as shapeType,
  string as stringType
  , useDataModel
} from '@thd-nucleus/data-sources';

const collectionHandler = ({ data }) => {
  const { collection } = data || {};
  const { metadata, taxonomy } = collection || {};
  const { breadCrumbs } = taxonomy || {};
  const category = (breadCrumbs || []).length ? breadCrumbs[0]?.label || '' : '';
  const { type, brandName = 'Shop By Room', name = '', canonicalUrl } = metadata || {};
  const canonical = `https://www.homedepot.com${canonicalUrl}`;
  const SEOTitle = type === 'Space' ? `${name} - ${category} - The Home Depot`
    : `${brandName} ${name} - The Home Depot`;
  const SEODescription = `Shop our ${category} Department to customize your ${name} today at The Home Depot`;
  const tags = [
    new TitleTag(SEOTitle),
    new MetaTag({ property: 'og:title', content: SEOTitle, id: 'ogTitle' }),
    new MetaTag({ name: 'description', content: SEODescription, id: 'description' }),
    new MetaTag({ property: 'og:description', content: SEODescription, id: 'ogDescription' }),
    new MetaTag({ property: 'og:url', content: canonical, id: 'ogUrl' }),
    new LinkTag({ rel: 'canonical', href: canonical, id: 'canonical' })
  ];
  return tags;
};

/**
 * Shop by room has not been migrated over to GQL, adding parameter options to support pre gql.
 * ie - remove everything but collectionId once shop by room is supported by gql
 * @param collectionId
 * @param description
 * @param title
 * @constructor
 */
export const CollectionMetadata = ({
  collectionId
}) => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('collection-metadata.ready');
  },
  []
  );
  const collectionDetailOptions = {
    variables: {
      collectionId
    },
  };
  const { data, loading, error } = useDataModel('collection', collectionDetailOptions);
  const props = {
    collectionId,
  };

  useHelmet('collectionMetadata', { data, props }, collectionHandler, [collectionId]);
  return null;
};

CollectionMetadata.displayName = 'CollectionMetadata';

CollectionMetadata.dataModel = {
  collection: params({ collectionId: stringType().isRequired() }).shape({
    metadata: shapeType({
      name: stringType(),
      brandName: stringType(),
      canonicalUrl: stringType(),
      type: stringType(),
    }),
    taxonomy: shapeType({
      breadCrumbs: arrayType(shapeType({
        label: stringType()
      }))
    })
  })
};

CollectionMetadata.propTypes = {
  collectionId: string.isRequired,
};
